import { render } from "./LbrxKioskSecondTheme.vue?vue&type=template&id=6cba983d&scoped=true"
import script from "./LbrxKioskSecondTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskSecondTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskSecondTheme.vue?vue&type=style&index=0&id=6cba983d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cba983d"]])

export default __exports__